export default function token(state = {}, action) {
  const { type } = action;
  if (type === 'SET_TOKEN') {
    const { token = {} } = action;
    return { ...state, ...token };
  }
  return state;
}
